<template>
  <div class="profilewrapper">
     <h3 class="text-center">Change Password</h3>
      <div class="profilebody">
          <b-container>
          
              <b-row>

                  <b-col cols="12">
                      <b-form-group label="Password">
                          <b-form-input 
                            type="password"
                            v-model="passwordform.password"
                            placeholder="Password"
                            :class="[{'is-invalid' : passwordform.password != passwordform.password_confirmation}]"
                            ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col cols="12">
                      <b-form-group label="Confirm Password">
                          <b-form-input 
                            type="password"
                            v-model="passwordform.password_confirmation"
                            :class="[{'is-invalid' : passwordform.password != passwordform.password_confirmation}]"
                            placeholder="Confirm Password"
                            ></b-form-input>
                      </b-form-group>
                  </b-col>

                 
                  <b-col cols="12">
                      <b-btn 
                        :disabled="disablebtn"
                        block 
                        @click="changepassword"
                        class="mt-3" 
                        variant="primary">Change Password</b-btn>

                      <b-btn 
                        @click="$router.push({name : 'profile'})"
                        block 
                        class="mt-3" 
                        variant="outline-primary">Cancel</b-btn>
                  </b-col>
              </b-row>
          </b-container>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            passwordform : {
                password_confirmation: '',
                password             : ''
            }
        }
    },
    computed : {
        /**
         * Logged in user profile
         */
        user : {
            get() {
                return this.$store.state.user
            },
            set(user) {
                this.$store.commit('updateuser', user)
            }
        },
        /**
         * disable change password button if not match and empty
         */
        disablebtn() {
            const password = this.passwordform;
            if(password.password == '' || password.password_confirmation == '') {
                return true;
            } else if(password.password_confirmation == password.password) {
                return false;
            } else {
                return true;
            }
        }
    },
    methods : {
        /**
         * Submit change new password
         */
        async changepassword() {
            const url = `/submit_forgot_new_password/${this.user.id}`
            const res = await axios.post(url, this.passwordform).catch(err => console.log(err))

            if(res.data.success) {
                this.$router.push({name : 'profile'})
            } 
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';

    .profilewrapper {
        padding-bottom : 30px;

        h3 {
            color      : $primaryColor;
            font-size  : 20px;
            font-weight: 700;
            padding    : 15px;
        }

        legend {
            font-size  : 12px;
            font-weight: 800;
        }

        .form-control {

            padding-left : 15px;

             &:read-only, &:disabled {
                padding-left : 0;
            }
          
        }

        .profilepicWrap {
            text-align   : center;
            margin-bottom: 30px;

            .profileimage {
                font-size: 100px;
                color    : $lightgrey2;
            }

            .uploadpic {
                color   : $primaryColor;
                position: relative;
                top     : 8px;
                cursor  : pointer;
            }
        }

        .editbtn {
            height      : 30px;
            padding     : 0 15px;
            

            &.btn {
                &.btn-outline-primary {
                    color       : $primaryColor;
                    border-color: $primaryColor;

                    &:hover, &:focus {
                        color  : white;
                        outline: none;
                    }
                }
            }
        }
    }
</style>